<script>
	import { isPortraitScreen } from '../js/model/stores';

	let _hotel;
	let portrait;

	let prepareScene = () => {
		if (!_hotel) {
			requestAnimationFrame(prepareScene);
		}

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();
</script>

<style>
	svg {
		position: absolute;
		right: 0;
		bottom: 0;
		width: auto;
		height: 24em;
		overflow: visible;
	}

	svg.portrait {
		height: 8em;
		right: -2em;
		bottom: -2em;
	}
</style>

<svg class:portrait width="260" height="416" viewBox="0 0 260 416" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="hotel" bind:this={_hotel}>
		<path d="M73 74H43V416H73V74Z" fill="#D60059"/>
		<path d="M47 0H0V416H47V0Z" fill="#5A97C3"/>
		<path d="M93 51H66V416H93V51Z" fill="#5A97C3"/>
		<path d="M135 51H108V416H135V51Z" fill="#5A97C3"/>
		<path d="M218 51H191V416H218V51Z" fill="#5A97C3"/>
		<path d="M260 51H232V416H260V51Z" fill="#5A97C3"/>
		<path d="M176 51H148V416H176V51Z" fill="#5A97C3"/>
	</g>
</svg>
